import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// EmptyState v1 ships minimal { text } per the 4 current prototype usages in
// chemicals-page.html, mix-detail.html, and create-mix.html (x2). A richer
// variant with icon + primary text + secondary hint exists in
// mix-tank-calculator.html:1044 createEmptyState() and in the
// PROTOTYPE_TO_COMPONENTS_MAPPING.md:416 "dashed border card" description.
// Defer until a second consumer in the SVM codebase needs the richer
// treatment; at that point either extend EmptyState with optional slots
// or extract a companion EmptyStateCard. Three-strikes rule applies.
//
// Scope: EmptyState handles empty list bodies and empty search results only.
// Status-driven panel emptiness (e.g. "Empty recipe" when a mix has zero
// chemicals) is handled by StatusPill with the warn variant, NOT EmptyState.
// If the emptiness conveys a status (something is wrong / needs attention),
// use StatusPill. If it conveys a state (list is empty, here's what to do),
// use EmptyState.

const EmptyState: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => (
    <VerticalContainer className={`${styles.emptyState} ${className}`} testId={testId}>
        <Wrapper className={styles.text}>{text}</Wrapper>
    </VerticalContainer>
);

export default EmptyState;
